import { forChargeCodeApi } from "@/config/charge-code-api";
import { lazyLoad } from "@/utils/lazyLoad";

// Main page components lazy loading
export const HomePage = lazyLoad(() => import("@/pages/Home"), { componentName: "HomePage" });
export const ShowcasePage = lazyLoad(() => import("@/pages/Showcase"), {
  componentName: "ShowcasePage",
});
export const Login = lazyLoad(() => import("@/pages/Login"), { componentName: "Login" });
export const LoginCallback = lazyLoad(() => import("@/pages/LoginCallback"), {
  componentName: "LoginCallback",
});

export const AdditionalInfo = lazyLoad(() => import("@/pages/AdditionalInfo"), {
  componentName: "AdditionalInfo",
});
export const TestPage = lazyLoad(() => import("@/pages/TestPage"), { componentName: "TestPage" });
// ECHO-3859 — ECHO 1.0 (TSPRG-HS) archive query
export const LegacyArchivePage = lazyLoad(() => import("@/pages/LegacyArchive"), {
  componentName: "LegacyArchivePage",
});

// Patient management related pages
export const PatientPage = lazyLoad(() => import("@/pages/Patient"), {
  componentName: "PatientPage",
});
export const PatientCreate = lazyLoad(() => import("@/pages/Patient/create"), {
  componentName: "Registration",
});
export const PatientEdit = lazyLoad(() => import("@/pages/Patient/edit"), {
  componentName: "PatientEdit",
});

// Appointment management related pages
export const AppointmentPage = lazyLoad(() => import("@/pages/Appointment/appointment"), {
  componentName: "AppointmentPage",
});
export const PreRegistrationPage = lazyLoad(() => import("@/pages/Appointment/pre-registration"), {
  componentName: "PreRegistrationPage",
});

// Queue management
export const QueuePage = lazyLoad(() => import("@/pages/QueueManagement"), {
  componentName: "QueuePage",
});

// Consultation related pages
export const ConsultationPage = lazyLoad(() => import("@/pages/Consultation"), {
  componentName: "ConsultationPage",
});
export const MedicalCoverage = lazyLoad(() => import("@/pages/Coverage"), {
  componentName: "MedicalCoverage",
});

// Inventory management related pages
export const InventoryList = lazyLoad(() => import("@/pages/Inventory/InventoryList"), {
  componentName: "InventoryList",
});
export const InventoryCreatePage = lazyLoad(
  () => import("@/pages/Inventory/InventoryList/create"),
  { componentName: "InventoryCreatePage" },
);
export const InventoryDetail = lazyLoad(() => import("@/pages/Inventory/InventoryList/detail"), {
  componentName: "InventoryDetail",
});
export const AdjustmentPage = lazyLoad(() => import("@/pages/Inventory/adjustment"), {
  componentName: "AdjustmentPage",
});
export const AdjustmentCreatePage = lazyLoad(() => import("@/pages/Inventory/adjustment/create"), {
  componentName: "AdjustmentCreatePage",
});
export const AdjustmentDetail = lazyLoad(() => import("@/pages/Inventory/adjustment/detail"), {
  componentName: "AdjustmentDetail",
});

// export const RequisitionPage = lazyLoad(() => import("@/pages/Inventory/requisition"), {
//   componentName: "RequisitionPage",
// });

// Delivery management
export const DeliveryPage = lazyLoad(() => import("@/pages/Inventory/delivery"), {
  componentName: "DeliveryPage",
});
export const DeliveryCreatePage = lazyLoad(() => import("@/pages/Inventory/delivery/create"), {
  componentName: "DeliveryCreatePage",
});
export const DeliveryEditPage = lazyLoad(() => import("@/pages/Inventory/delivery/edit"), {
  componentName: "DeliveryEditPage",
});

// Supplier management
export const SuppliersPage = lazyLoad(() => import("@/pages/Inventory/suppliers"), {
  componentName: "SuppliersPage",
});
export const SupplierFormPage = lazyLoad(() => import("@/pages/Inventory/suppliers/create"), {
  componentName: "SupplierFormPage",
});

// Eden consumption message history
export const EdenConsumptionPage = lazyLoad(
  () => import("@/pages/ErpIntegration/eden-consumption"),
  { componentName: "EdenConsumptionPage" },
);

// Item master batch and item processing history
export const ItemMasterPage = lazyLoad(() => import("@/pages/ErpIntegration/item-master"), {
  componentName: "ItemMasterPage",
});

// Dispensing management
export const DispensingPage = lazyLoad(() => import("@/pages/Inventory/dispensing"), {
  componentName: "DispensingPage",
});
export const DispensingCreatePage = lazyLoad(() => import("@/pages/Inventory/dispensing/create"), {
  componentName: "DispensingCreatePage",
});
export const DispensingEditPage = lazyLoad(() => import("@/pages/Inventory/dispensing/edit"), {
  componentName: "DispensingEditPage",
});
export const DispensingFinalizePage = lazyLoad(
  () => import("@/pages/Inventory/dispensing/finalize"),
  {
    componentName: "DispensingFinalizePage",
  },
);

// Charge Code Management
export const ChargeCodeManagementPage = lazyLoad(() => import("@/pages/ChargeCodeManagement"), {
  componentName: "ChargeCodeManagementPage",
});

// Charge Code V2 stock
export const DeliveryOrderV2Page = lazyLoad(() => import("@/pages/ChargeCodeV2/DeliveryOrderV2"), {
  componentName: "DeliveryOrderV2Page",
});
export const DeliveryOrderV2FormPage = lazyLoad(
  () => import("@/pages/ChargeCodeV2/DeliveryOrderV2/form"),
  {
    componentName: "DeliveryOrderV2FormPage",
  },
);
export const DeliveryOrderV2DetailPage = lazyLoad(
  () => import("@/pages/ChargeCodeV2/DeliveryOrderV2/detail"),
  {
    componentName: "DeliveryOrderV2DetailPage",
  },
);
export const InventoryV2Page = lazyLoad(() => import("@/pages/ChargeCodeV2/InventoryV2"), {
  componentName: "InventoryV2Page",
});
export const InventoryAdjustmentV2Page = lazyLoad(
  () => import("@/pages/ChargeCodeV2/InventoryAdjustmentV2"),
  {
    componentName: "InventoryAdjustmentV2Page",
  },
);
export const InventoryAdjustmentV2FormPage = lazyLoad(
  () => import("@/pages/ChargeCodeV2/InventoryAdjustmentV2/form"),
  {
    componentName: "InventoryAdjustmentV2FormPage",
  },
);
export const InventoryAdjustmentV2DetailPage = lazyLoad(
  () => import("@/pages/ChargeCodeV2/InventoryAdjustmentV2/detail"),
  {
    componentName: "InventoryAdjustmentV2DetailPage",
  },
);
export const MovementV2Page = lazyLoad(() => import("@/pages/ChargeCodeV2/MovementV2"), {
  componentName: "MovementV2Page",
});

// Pharmacy management
// export const PharmacyPage = lazyLoad(() => import("@/pages/Pharmacy"), {
//   componentName: "PharmacyPage",
// });
// export const PharmacyDetailPage = lazyLoad(() => import("@/pages/Pharmacy/Detail"), {
//   componentName: "PharmacyDetailPage",
// });
// Investigation related pages
export const ReportsPage = lazyLoad(() => import("@/pages/Reports"), {
  componentName: "ReportsPage",
});

// Investigation related pages
export const InvestigationsPage = lazyLoad(() => import("@/pages/Investigations"), {
  componentName: "InvestigationsPage",
});

// Invoice management
export const InvoiceListPage = lazyLoad(() => import("@/pages/Invoice"), {
  componentName: "InvoiceListPage",
});
export const InvoiceMedicalCoveragePage = lazyLoad(
  () => import("@/pages/Invoice/medical-coverage"),
  {
    componentName: "InvoiceMedicalCoveragePage",
  },
);
export const CorporateInvoiceDetailPage = lazyLoad(
  () => import("@/pages/Invoice/medical-coverage/CorporateInvoiceDetail"),
  {
    componentName: "CorporateInvoiceDetailPage",
  },
);
export const InvoiceCreditNotePage = lazyLoad(() => import("@/pages/Invoice/credit-note"), {
  componentName: "InvoiceCreditNotePage",
});
export const InvoiceCreditNoteDetailPage = lazyLoad(
  () => import("@/pages/Invoice/credit-note/detail"),
  {
    componentName: "InvoiceCreditNoteDetailPage",
  },
);

// Service management
export const MedicalServicesPage = lazyLoad(() => import("@/pages/Services/MedicalServices"), {
  componentName: "MedicalServicesPage",
});
export const CreateMedicalService = lazyLoad(
  () => import("@/pages/Services/MedicalServices/Create"),
  { componentName: "CreateMedicalService" },
);
export const PackagePage = lazyLoad(() => import("@/pages/Services/Package"), {
  componentName: "PackagePage",
});
export const CreatePackage = lazyLoad(() => import("@/pages/Services/Package/create"), {
  componentName: "CreatePackage",
});
export const UpdatePackage = lazyLoad(() => import("@/pages/Services/Package/edit"), {
  componentName: "UpdatePackage",
});
export const PackagesV2Page = lazyLoad(() => import("@/pages/Services/PackagesV2"), {
  componentName: "PackagesV2Page",
});
export const CreatePackageV2Page = lazyLoad(() => import("@/pages/Services/PackagesV2/create"), {
  componentName: "CreatePackageV2Page",
});

// Settings related pages
export const SettingsListPage = lazyLoad(() => import("@/pages/Settings/MedicalTemplate"), {
  componentName: "SettingsListPage",
});
export const SettingsDetailPage = lazyLoad(
  () => import("@/pages/Settings/MedicalTemplate/Detail"),
  { componentName: "SettingsDetailPage" },
);
export const DischargeAdviceListPage = lazyLoad(() => import("@/pages/Settings/DischargeAdvice"), {
  componentName: "DischargeAdviceListPage",
});
export const DischargeAdviceDetailPage = lazyLoad(
  () => import("@/pages/Settings/DischargeAdvice/Detail"),
  { componentName: "DischargeAdviceDetailPage" },
);
export const SystemPreferencesListPage = lazyLoad(
  () => import("@/pages/Settings/SystemPreferences"),
  { componentName: "SystemPreferencesListPage" },
);

export const ThemeSettingsPage = lazyLoad(() => import("@/pages/Settings/ThemeSettings"), {
  componentName: "ThemeSettingsPage",
});
export const UserManagementListPage = lazyLoad(() => import("@/pages/Settings/UserManagement"), {
  componentName: "UserManagementListPage",
});
export const CreateUserPage = lazyLoad(() => import("@/pages/Settings/UserManagement/CreateUser"), {
  componentName: "CreateUserPage",
});
export const EditUserPage = lazyLoad(() => import("@/pages/Settings/UserManagement/EditUser"), {
  componentName: "EditUserPage",
});

// Role management
export const RoleManagementPage = lazyLoad(() => import("@/pages/Settings/RoleManagement"), {
  componentName: "RoleManagementPage",
});

// Vendor management
export const VendorManagementPage = lazyLoad(() => import("@/pages/Settings/VendorManagement"), {
  componentName: "VendorManagementPage",
});
export const VendorForm = lazyLoad(
  () =>
    forChargeCodeApi({
      v1: () => import("@/pages/Settings/VendorManagement/VendorForm"),
      v2: () => import("@/pages/Settings/VendorManagement/VendorForm.v2"),
    })(),
  { componentName: "VendorForm" },
);

// Print pages
export const PrintMedicationLabelPage = lazyLoad(() => import("@/pages/Print/MedicationLabel"), {
  componentName: "PrintMedicationLabelPage",
});
export const PrintPatientLabelPage = lazyLoad(() => import("@/pages/Print/PatientLabel"), {
  componentName: "PrintPatientLabelPage",
});
export const PrintMailingLabelPage = lazyLoad(() => import("@/pages/Print/MailingLabel"), {
  componentName: "PrintMailingLabelPage",
});
export const PrintLetterMCsPage = lazyLoad(() => import("@/pages/Print/LetterMCs"), {
  componentName: "PrintLetterMCsPage",
});
export const PrintCorporateInvoicePage = lazyLoad(() => import("@/pages/Print/CorporateInvoice"), {
  componentName: "PrintCorporateInvoicePage",
});
export const PrintAdmissionFormPage = lazyLoad(() => import("@/pages/Print/AdmissionForm"), {
  componentName: "PrintAdmissionFormPage",
});
export const PrintSOAPage = lazyLoad(() => import("@/pages/Print/StatementOfAccount"), {
  componentName: "PrintSOAPage",
});
export const PrintPaymentReceiptPage = lazyLoad(() => import("@/pages/Print/PaymentReceipt"), {
  componentName: "PrintPaymentReceiptPage",
});

export const PrintCreditNotePage = lazyLoad(() => import("@/pages/Print/CreditNoteInvoice"), {
  componentName: "PrintCreditNotePage",
});

export const PrintItemizedInvoicePage = lazyLoad(() => import("@/pages/Print/ItemizedInvoice"), {
  componentName: "PrintItemizedInvoicePage",
});

export const PrintUnitemizedInvoicePage = lazyLoad(
  () => import("@/pages/Print/UnitemizedInvoice"),
  {
    componentName: "PrintUnitemizedInvoicePage",
  },
);
export const PrintConsultNotePage = lazyLoad(() => import("@/pages/Print/ConsultNote"), {
  componentName: "PrintConsultNotePage",
});
export const PrintRadiologyOrdersPage = lazyLoad(() => import("@/pages/Print/RadiologyOrders"), {
  componentName: "PrintRadiologyOrdersPage",
});
export const PrintRadiologyLabelPage = lazyLoad(() => import("@/pages/Print/RadiologyLabel"), {
  componentName: "PrintRadiologyLabelPage",
});
export const PrintRadiologyEOrderFormPage = lazyLoad(
  () => import("@/pages/Print/RadiologyEOrderForm"),
  { componentName: "PrintRadiologyEOrderFormPage" },
);
//
// RAD & LAB management
export const RadLabManagementPage = lazyLoad(() => import("@/pages/RadLabManagement"), {
  componentName: "RadLabManagementPage",
});
